<template>
  <div class="container-fluid">
    <div class="row heading no-gutters">
      <div class="col-md-12"><span class="brand">yield.IO</span>
        <span> bond charts updated daily</span>
        <a class="about" href="#" @click="onShowAbout">About</a>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-md-12">
        <YieldHistory
          :yields-for-duration="yieldsForDuration"
          @onDurationChange="onDurationChange"
          @onDateChange="onDateChange"/>
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col-md-5">
        <YieldCallout :current-date="date"
                      :yields-for-date="yieldsForDate"
                      :duration-in-months="durationInMonths" />

        <YieldTable :yields-for-date="yieldsForDate" :current-date="date"/>
      </div>

      <div class="col-md-7">
        <YieldCurve :yields-for-date="yieldsForDate" :current-date="date"/>
        <YieldSpread :all-yields="allYields"/>
        <YieldDistribution :all-yields="allYields" :duration-in-months="durationInMonths"/>
      </div>
    </div>
    <About :shown="showAbout" @close="onCloseAbout" />
  </div>
</template>

<script>
import About from './About';
import YieldHistory from './YieldHistory';
import YieldCallout from './YieldCallout';
import YieldCurve from './YieldCurve';
import YieldSpread from './YieldSpread';
import YieldDistribution from './YieldDistribution';
import YieldTable from './YieldTable';
import * as data from '../../../client/src/data.js';

export default {
  name: 'YieldLayout',
  components: {About, YieldHistory, YieldCallout, YieldSpread, YieldDistribution, YieldCurve, YieldTable},
  data () {
    return {
      durationInMonths: 120,
      date: null,
      allYields: null,
      showAbout: false
    }
  },
  computed: {
    yieldsForDate() {
      return this.date ? data.getYieldsForDate(this.date) : null;
    },
    yieldsForDuration() {
      if (this.allYields) {
        return data.getYieldsForDuration(this.durationInMonths);
      }
      return null;
    }
  },
  methods: {
    onDurationChange(duration) {
      this.durationInMonths = duration;
    },
    onDateChange(date) {
      this.date = date;
    },
    onShowAbout() {
      console.log('showAbout');
      this.showAbout = true;
    },
    onCloseAbout() {
      console.log('closeAbout');
      this.showAbout = false;
    }
  },
  async created () {
    this.allYields = await data.getAllYields();
    this.date = new Date(this.allYields[this.allYields.length - 1][0]);
  },
};
</script>

